<fa-icon
  *ngIf="resources && (hasFeature('quiz-mp') || hasFeature('quiz-sp'))"
  placement="top"
  ngbTooltip="Quiz"
  [class]="res.QUIZ ? 'present':'none'"
  [class]=""
  icon="question-circle"
  [size]="size"
>
</fa-icon>
<fa-icon *ngIf="resources" placement="top" ngbTooltip="Wiki" [class]="res.WIKI ? 'present':'none'" icon="book-alt" [size]="size"> </fa-icon>
<fa-icon
  *ngIf="resources && hasFeature('glossary')"
  placement="top"
  ngbTooltip="Glossary"
  [class]="res?.GLOSSARY ? 'present':'none'"
  icon="search-plus"
  [size]="size"
>
</fa-icon>
<fa-icon
  *ngIf="resources && hasFeature('impuls')"
  placement="top"
  ngbTooltip="Impuls"
  [class]="res.IMPULS ? 'present':'none'"
  icon="list"
  [size]="size"
>
</fa-icon>
<fa-icon
  *ngIf="resources && hasFeature('casestudy')"
  placement="top"
  ngbTooltip="Casestudy"
  [class]="res.CASESTUDY ? 'present':'none'"
  icon="file-edit"
  [size]="size"
>
</fa-icon>
<fa-icon *ngIf="resources" placement="top" ngbTooltip="Media" [class]="res.MEDIA ? 'present':'none'" icon="image" [size]="size"> </fa-icon>
<fa-icon
  *ngIf="resources && hasFeature('flashcard')"
  placement="top"
  ngbTooltip="Flashcard"
  [class]="res.FLASHCARD ? 'present':'none'"
  icon="th-large"
  [size]="size"
>
</fa-icon>
<fa-icon
  *ngIf="resources && hasFeature('description')"
  placement="top"
  ngbTooltip="Description"
  [class]="res.DESCRIPTION ? 'present':'none'"
  icon="info-square"
  [size]="size"
>
</fa-icon>
